var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 16.667,
    viewBox: "0 0 16.667 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#0075c9;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.667px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.833 0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.5,12.5v3.333A1.667,1.667,0,0,1,15.833,17.5H4.167A1.667,1.667,0,0,1,2.5,15.833V12.5",
    transform: "translate(-2.5 -2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.833,8.333,10,12.5l4.167-4.167",
    transform: "translate(-2.5 -2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,12.5V2.5",
    transform: "translate(-2.5 -2.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ec4749e9d582873561179d0e38bff355.svg";
export { ForwardRef as ReactComponent };